module.exports = {
  locales: ["pt"],
  defaultLocale: "pt",
  pages: {
    "*": ["common", "seo"],
  },
};
